<template>
  <header v-if="retailerId === 'DFS'" class="wrapper">
    <img class="logo" alt="DFS" src="./../assets/img/dfs-logo.png" />
  </header>
  <header v-else class="sof-header">
    <div class="sof-logo">
      <img class="sof-logo__brand" alt="Sofology" src="./../assets/img/sof-logo.png" />
    </div>
    <img class="sodelco-logo" alt="In partnership with The Sofa Delivery Co Installation Experts" src="./../assets/img/sodelco-logo-1x.png" srcset="./../assets/img/sodelco-logo-1x.png 1x, ./../assets/img/sodelco-logo-2x.png 2x, ./../assets/img/sodelco-logo-3x.png 3x" />
  </header>
</template>
<script>
export default {
  name: "Header",
  props: ['retailerId']
}
</script>
<style lang="scss">
  .sof-header {
    text-align: center;
  }
  .sof-logo {
    background-color: #000;
    padding: 25px;
    &__brand {
      width: 164px;
      height: auto;
    }
  }
  .sodelco-logo {
    width: 202px;
    height: auto;
    margin-top: 30px;
    @media (min-width: 768px) {
      margin-top: 50px;
    }
  }
</style>
